import script from "./MonitoringView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonitoringView.vue?vue&type=script&setup=true&lang=ts"

import "./MonitoringView.vue?vue&type=style&index=0&id=2abf8f5c&lang=css"

const __exports__ = script;

export default __exports__